export const withRequestDeadline = async (
  operation,
  { timeoutMs = 12000, message = "La conexion tardo demasiado. Vuelve a intentar." } = {}
) => {
  const controller = new AbortController();
  let timer;

  try {
    return await Promise.race([
      Promise.resolve().then(() => operation(controller.signal)),
      new Promise((resolve, reject) => {
        timer = setTimeout(() => {
          const error = new Error(message);
          error.code = "REQUEST_TIMEOUT";
          reject(error);
          controller.abort();
        }, timeoutMs);
      }),
    ]);
  } finally {
    clearTimeout(timer);
  }
};
